import { render, staticRenderFns } from "./step-card.vue?vue&type=template&id=271d323c&"
import script from "./step-card.vue?vue&type=script&lang=js&"
export * from "./step-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports